<div class="alert" [ngStyle]="{ margin: margin }">
  <span class="icon-info"></span>
  <p class="content" [innerHTML]="msg"></p>
</div>
